import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const sidePanelDefaultVariants = {
  "divider": "line"
}
const sidePanelCompoundVariants = []

const sidePanelSlotNames = [
  [
    "root",
    "sidePanel__root"
  ],
  [
    "main",
    "sidePanel__main"
  ],
  [
    "panel",
    "sidePanel__panel"
  ],
  [
    "panelInner",
    "sidePanel__panelInner"
  ],
  [
    "header",
    "sidePanel__header"
  ],
  [
    "title",
    "sidePanel__title"
  ],
  [
    "description",
    "sidePanel__description"
  ],
  [
    "body",
    "sidePanel__body"
  ],
  [
    "footer",
    "sidePanel__footer"
  ]
]
const sidePanelSlotFns = /* @__PURE__ */ sidePanelSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, sidePanelDefaultVariants, getSlotCompoundVariant(sidePanelCompoundVariants, slotName))])

const sidePanelFn = memo((props = {}) => {
  return Object.fromEntries(sidePanelSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const sidePanelVariantKeys = [
  "divider"
]
const getVariantProps = (variants) => ({ ...sidePanelDefaultVariants, ...compact(variants) })

export const sidePanel = /* @__PURE__ */ Object.assign(sidePanelFn, {
  __recipe__: false,
  __name__: 'sidePanel',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: sidePanelVariantKeys,
  variantMap: {
  "divider": [
    "line",
    "gap"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, sidePanelVariantKeys)
  },
  getVariantProps
})